import { ReactGoogleReviews } from "react-google-reviews";
import "react-google-reviews/dist/index.css"; // Import the necessary CSS

function MyReviewsSection() {
  // Replace "YOUR_FEATURABLE_ID" with the actual ID you copied in Step 1
  const featurableWidgetId = "37dd5bcf-e100-4429-b823-c991beea94ff";

  return (
    <div className="reviews-container">

      {/* Example using the 'carousel' layout */}
      <ReactGoogleReviews
        layout="carousel"
        featurableId={featurableWidgetId}
        carouselAutoplay={true}
        carouselSpeed={5000} // Autoplay speed in milliseconds
      />
      
      {/* You can also use the 'badge' layout in another part of your app */}
      {/* <ReactGoogleReviews layout="badge" featurableId={featurableWidgetId} /> */}
    </div>
  );
}

export default MyReviewsSection;
